import { render, staticRenderFns } from "./TagNavPanel.vue?vue&type=template&id=1be64201&"
import script from "./TagNavPanel.vue?vue&type=script&lang=js&"
export * from "./TagNavPanel.vue?vue&type=script&lang=js&"
import style0 from "./TagNavPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports